import React from 'react';
import StatusPage from '../components/StatusPage';

export default function Failure() {
  return (
    <StatusPage
      variant="failure"
      icon="❌"
      title="El pago no pudo procesarse"
      message="Ocurrió un error con tu pago. Por favor, intentá nuevamente."
    />
  );
}
